import {createAction} from '@reduxjs/toolkit'
import {isEventDetailsPageHiddenInternal} from '@wix/wix-events-commons-statics'
import {navigateToDetailsPage} from '../../../../commons/services/navigation'
import {isEventRestricted} from '../selectors/events'
import {createAsyncAction} from '../services/redux-toolkit'
import {ensureLoggedIn} from './members'

export const navigateToPage = createAsyncAction<boolean, {event: wix.events.Event}>(
  'NAVIGATE_TO_PAGE',
  async ({event}, {dispatch, getState, extra: {wixCodeApi}}) => {
    dispatch(rsvpButtonClicked({event}))
    const state = getState()
    const detailsPageEnabled = !isEventDetailsPageHiddenInternal(event)

    const isRestricted = isEventRestricted(state, event)
    if (!isRestricted || (await dispatch(ensureLoggedIn()))) {
      await navigateToDetailsPage(event, detailsPageEnabled, wixCodeApi)

      return true
    }

    return false
  },
)

export const onLinkNavigatedToPage = createAction<{event: wix.events.Event}>('ON_LINK_NAVIGATED_TO_PAGE')

export const rsvpButtonClicked = createAction<{event: wix.events.Event}>('RSVP_BUTTON_CLICKED')

export const navigatedToPage = createAction<{event: wix.events.Event}>('NAVIGATED_TO_PAGE')
